import { Box, Card, CardContent, Typography } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, TokenAmount } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'

import { EthBlock } from '../../Components'
import { parseBigNumber } from '../../parseBigNumber'

interface BidPlacedEventProps {
  event: XyoWorldMinterEvents.BidPlaced
}

const BidPlacedEventCard: React.FC<BidPlacedEventProps> = (props) => {
  const { event } = props
  const { id, amount } = event.args
  const eventBlock = event.blockNumber
  const quadkey = Quadkey.fromBase10String(id.toString())
  const byAddress = EthAddress.fromString(id.toString())
  const amountBN = parseBigNumber(amount)
  return (
    <Box margin={1}>
      <Card>
        <CardContent>
          <Box alignItems="center" display="flex" flexWrap="wrap">
            <Box padding={1}>
              <EthAccountButton variant="outlined" address={byAddress} />
            </Box>
            <Typography variant="body1">placed a</Typography>
            <TokenAmount amount={amountBN} />
            <Typography variant="body1">bid for geotoken #{quadkey?.toBase4Hash()}</Typography>
            <Typography variant="body1">&nbsp;on block</Typography>
            <EthBlock block={eventBlock} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default BidPlacedEventCard
